import request from '@/utils/request'
import { formatParam } from '@/utils/tool'
import {
  REQ_PRODUCT
} from './platform-api'

// 渠道图片列表
export function getMediaDetail (params: {
  mediaId: string, // 渠道
  platId: string // 平台
}): Promise<string[]> {
  return request(`/saas/gtpw/platform/getMediaDetail?${formatParam(params)}`)
}

// 平台banner获取
export function getPlatformBanner (params: {
  platId: string
}): Promise<string> {
  return request(`/saas/gtpw/platform/getPlatformBanner?${formatParam(params)}`)
}

// 全球货仓产品列表查询，treeId对应根据custProductTypies接口返回的id来对应
export function getPlatformProducts (params: REQ_PRODUCT): any {
  return request(`/saas/gtpw/platform/lark/products?${formatParam(params)}`)
}

// 平台列表
export function getPlatforms (params?: {
  autoCount?: boolean,
  name?: string,
  page?: number,
  resultNum?: number,
  sort?: string,
  startIndex?: number
}): any {
  return request(`/saas/gtpw/platform/platforms?${formatParam(params)}`)
}
